/*! SuppressStringValidation header name */
export const glowAuthenticationResultHeaderName = "Glow-Authentication-Result";
